import type { ProductFeatureConfig } from '../../../types/insurances/ProductFeatureConfig';

export const product: ProductFeatureConfig = {
    overview: {
        showSharedOverview: false,
        details: {
            showStatus: false,
            showVariant: false,
            showPackage: false,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
};
